var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.fullName}},[_c('b-avatar',{attrs:{"badge":_vm.badge,"text":_vm.initials}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }